<template>
  <div class="login" style="background: url(static/img/background.jpg)">
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12 sm10 offset-sm1 md6 offset-md3 lg4 offset-lg4>
          <transition name="el-zoom-in-top">
            <v-card class="card-login">
              <v-card-text class="card-login-text">
                <img
                  src="static/logo/logo.svg"
                  width="80%"
                  class="mx-auto mt-5"
                  style="margin-bottom: 96px !important"
                />
                <v-form>
                  <p class="text-xs-left">Login</p>
                  <v-text-field
                    name="login"
                    label="Usuário"
                    color="primary"
                    v-model="login"
                    type="text"
                    prepend-inner-icon="person"
                    required
                    solo
                  ></v-text-field>

                  <p class="text-xs-left">Senha</p>
                  <v-text-field
                    id="password"
                    name="password"
                    color="primary"
                    v-model="senha"
                    label="Senha"
                    type="password"
                    prepend-inner-icon="key"
                    required
                    solo
                  ></v-text-field>
                  <div class="text-xs-right">
                    <v-btn
                      color="primary"
                      class="mx-0"
                      @click="doLogin()"
                      :plain="true"
                    >
                      Entrar
                    </v-btn>
                  </div>
                </v-form>
              </v-card-text>
            </v-card>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
    <div class="content-login" style="display: none">
      <div
        class="background-login"
        style="background-image: url('./static/img/wallpaper.jpg')"
      >
        <div class="wall-login"></div>
      </div>

      <v-flex class="login-center">
        <transition name="el-zoom-in-top">
          <v-card v-if="logshow" v-show="show2">
            <article class="logo-login">
              <img src="static/logo/logo.png" width="316" />
            </article>

            <span class="line-login"></span>

            <v-card-text class="form-login">
              <!-- title login -->

              <div class="form-title-login">
                <h3 class="title-login">Login</h3>

                <p class="subtitle-login">Faça seu login para continuar</p>
              </div>

              <!-- puts login -->

              <v-form class="form-puts-login">
                <v-text-field
                  name="login"
                  label="Usuário"
                  color="primary"
                  v-model="login"
                  type="text"
                  required
                ></v-text-field>

                <v-text-field
                  id="password"
                  name="password"
                  color="primary"
                  v-model="senha"
                  label="Senha"
                  type="password"
                  required
                ></v-text-field>
              </v-form>

              <!-- <div class="danger-alert"" />
               -->
            </v-card-text>

            <!-- btns login -->

            <v-card-actions class="flex-center">
              <v-btn color="primary" @click="doLogin()" :plain="true"
                >Entrar</v-btn
              >
            </v-card-actions>
          </v-card>
        </transition>
      </v-flex>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

try {
  var Authentication = require("@/services/authentication").default;
} catch (err) {
  var Authentication = require("@/framework/services/authentication").default;
}

export default {
  data() {
    return {
      login: "",
      senha: "",
      error: null,
      logshow: false,
      show2: true,
    };
  },
  mounted() {
    setTimeout(() => {
      this.logshow = true;
    }, 800);
  },
  methods: {
    async doLogin() {
      try {
        const response = await Authentication.login({
          login: this.login,
          senha: this.senha,
        });
        this.$store.dispatch("setToken", response.data.token);
        this.$store.dispatch("setUser", response.data.user);

        this.$router.push({
          name: "adminpage-cockpit",
        });
      } catch (error) {
        console.log(error);

        // this.error = error.response.data.error;
        this.$message({
          showClose: true,
          message:
            "Ops! Email ou senha não correspondem ou você não tem acesso.",
          type: "error",
        });
      }
    },
  },
  components: {},
};
</script>

<style lang="scss">
@import "@/theme/styles/base.scss";

.login {
  width: 100svw;
  height: 100svh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: cover !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
  background-attachment: fixed !important;

  .card-login {
    backdrop-filter: blur(6px) brightness(0.8) !important;
    background: tint($body-color, 70%);
    border: 1px solid tint($brand-primary, 90%) !important;
    border-radius: 3rem !important;

    .card-login-text {
      padding: 32px 80px 32px 80px !important;
    }
  }
}

.card-vitor {
  background: lighten($body-color, 3%) !important; //$body-color !important;
}

.el-zoom-in-top-enter-active {
  transition-delay: 0.3s !important;
}
</style>
